// Recusrive tree search function that matches any item in the `items` argument list
// either if its `value` property matches the `value` argument, either if any of its
// sub children `value` property matches that `value` argument.
//
export default function findItemWithMatchingChildValue(items, value) {
  return items.find(
    (item) =>
      item.value === value ||
      (item.children && findItemWithMatchingChildValue(item.children, value))
  );
}
